export const ANIMATION_RENDER_LIMITS = {
  /** Review video frame rate cap. */
  maxVideoFps: 30,
  defaultVideoFps: 15,
  /** Longest review video interval, in seconds. */
  maxVideoSeconds: 15,
  defaultContactSheetFrames: 8,
  maxContactSheetFrames: 12,
  /** Longest contact sheet edge. Larger sheets are scaled down. */
  maxContactSheetEdgePx: 4096,
  /** Pixels held as decoded frames while a video is recorded. */
  maxVideoFramePixels: 120_000_000,
} as const;

export const ANIMATION_DELIVERY_LIMITS = {
  /** Video up to this size is embedded in the tool result. */
  maxEmbeddedBytes: 6 * 1024 * 1024,
  artifactTtlSeconds: 60 * 60,
} as const;
